import React, { useState } from 'react';
import { ModalContext } from '@/utils/contexts/ModalContext';

import ModalDeleteChange from '@/views/components/Modal/ModalDeleteChange';
import ModalDeleteLetter from '@/views/components/Modal/ModalDeleteLetter';
import ModalDeleteTemplate from '@/views/components/Modal/ModalDeleteTemplate';
import ModalImportFinalVersion from '@/views/components/Modal/ModalImportFinalVersion';
import ModalText from '@/views/components/Modal/ModalText';
import ModalContinueSimplification from '@/views/components/Modal/ModalContinueSimplification';
import ModalCheckTemplateAfterSimplification from '@/views/components/Modal/ModalCheckTemplateAfterSimplification';
import ModalHowToCreateSimpleTexts from '@/views/components/Modal/ModalHowToCreateSimpleTexts';
import ModalLetterMetadata from '@/views/components/Modal/ModalLetterMetadata';

import ModalOnboarding from '@/views/components/Modal/Onboarding/ModalOnboarding';
import ModalSimplification from '@/views/components/Modal/Simplification/ModalSimplification';

const ModalWrapper = ({ children }) => {
	const [ modalComponentName, setModalComponentName ] = useState(null);
	const [ modalAdditionalInfo, setModalAdditionalInfo ] = useState(null);
	
	const showModal = ({ componentName, additionalInfo = null }) => {
		setModalComponentName(componentName);
		setModalAdditionalInfo(additionalInfo);
	};
	const closeModal = () => {
		setModalComponentName(null);
		setModalAdditionalInfo(null);
	};

	return (
		<>
			<ModalContext.Provider
				value={ {
					showModal,
					closeModal,
					modalAdditionalInfo,
					setModalAdditionalInfo,
				} }
			>
				{ modalComponentName && modalComponentName === 'ModalDeleteChange' && (
					<div className='modal__wrapper'>
						<div
							className='modal__wrapper--background'
							onClick={ closeModal }
						/>
						<ModalDeleteChange />
					</div>
				)}
				{ modalComponentName && modalComponentName === 'ModalDeleteLetter' && (
					<div className='modal__wrapper'>
						<div
							className='modal__wrapper--background'
							onClick={ closeModal }
						/>
						<ModalDeleteLetter />
					</div>
				)}
				{ modalComponentName && modalComponentName === 'ModalDeleteTemplate' && (
					<div className='modal__wrapper'>
						<div
							className='modal__wrapper--background'
							onClick={ closeModal }
						/>
						<ModalDeleteTemplate />
					</div>
				)}
				{ modalComponentName && modalComponentName === 'ModalImportFinalVersion' && (
					<div className='modal__wrapper'>
						<div
							className='modal__wrapper--background'
							onClick={ closeModal }
						/>
						<ModalImportFinalVersion />
					</div>
				)}

				{ modalComponentName && modalComponentName === 'ModalText' && (
					<div className='modal__wrapper'>
						<div
							className='modal__wrapper--background'
							onClick={ closeModal }
						/>
						<ModalText />
					</div>
				)}

				{ modalComponentName && modalComponentName === 'ModalContinueSimplification' && (
					<div className='modal__wrapper'>
						<div
							className='modal__wrapper--background'
							onClick={ closeModal }
						/>
						<ModalContinueSimplification />
					</div>
				)}

				{ modalComponentName && modalComponentName === 'ModalCheckTemplateAfterSimplification' && (
					<div className='modal__wrapper'>
						<div
							className='modal__wrapper--background'
							onClick={ closeModal }
						/>
						<ModalCheckTemplateAfterSimplification />
					</div>
				)}

				{ modalComponentName && modalComponentName === 'ModalHowToCreateSimpleTexts' && (
					<div className='modal__wrapper'>
						<div
							className='modal__wrapper--background'
							onClick={ closeModal }
						/>
						<ModalHowToCreateSimpleTexts />
					</div>
				)}

				{ modalComponentName && modalComponentName === 'ModalLetterMetadata' && (
					<div className='modal__wrapper'>
						<div
							className='modal__wrapper--background'
							onClick={ closeModal }
						/>
						<ModalLetterMetadata />
					</div>
				)}

				{ modalComponentName && modalComponentName === 'ModalOnboarding' && (
					<div className='modal__wrapper'>
						<div
							className='modal__wrapper--background'
							onClick={ closeModal }
						/>
						<ModalOnboarding />
					</div>
				)}
				
				{ modalComponentName && modalComponentName === 'ModalSimplification' && (
					<div className='modal__wrapper'>
						<div
							className='modal__wrapper--background'
							onClick={ closeModal }
						/>
						<ModalSimplification />
					</div>
				)}

				{children}
			</ModalContext.Provider>
		</>
	);

};

export default ModalWrapper;